exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alerts[data-v-421511ac] {\n    left: auto;\n}\n", ""]);

// exports
